// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/ee4407cbac581107fa31.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"8e451478023f8b5c535a","216":"0a8f5b8445b5e1a2afe6","217":"2d0e30cde303f820790b"}[chunkId] + ".chunk.js";
};